(function () {
    angular.module('tmx-app')
        .controller('usersEditCtrl', ['$stateParams', '$timeout','tmxUtility', 'resolvedData', 'lookupService',
            '$state', '$mdDialog', 'BranchService', 'UsersService', '$http', 'APP_CONSTANTS', 'TMX_FINANCE_CONSTANTS', 'cacheStore', 'tmxResource', 'ToastService',

            function UsersEditCtrl($stateParams, $timeout, tmxUtility, resolvedData, lookupService, $state, $mdDialog,
                BranchService, UsersService, $http, APP_CONSTANTS, TMX_FINANCE_CONSTANTS, cacheStore, tmxResource, ToastService) {
                var userVM = this;
                var exists = tmxUtility.exists;
                var lkupType = TMX_FINANCE_CONSTANTS.LOOKUP_TYPES;
                var vitasTenants = ["vitas", "vitas-leb", "vitas-eg", "vitas-irq"];
                var now = new Date();
                var utcDate = new Date(now.getTime() + now.getTimezoneOffset() * 60000);
                userVM.showLoginToServer = false;
                userVM.holidayGridColumn = angular.copy(UsersService.holidayGridColumn);
                userVM.HolidayData = {};
                var holidaysLoadedFromServer = false;
                userVM.minHolidayStartDate = new Date(moment(new Date()).startOf('day').toDate().toJSON());
                userVM.HolidayData.HolidayStartDate = new Date(moment(new Date()).startOf('day').toDate().toJSON());
                userVM.minHolidayEndDate = new Date(moment(new Date()).startOf('day').toDate().toJSON());
                userVM.addState = $state.current.name.indexOf('.add') > 0;
                userVM.formatDate=tmxUtility.formatDateForCompany;

                userVM.HolidayStatus = [
                    {
                        HiddenValue: "0",
                        VisibleValue: "No"
                    },
                    {
                        HiddenValue: "1",
                        VisibleValue: "Yes"
                    }
                ];

                userVM.ProcessStatus = [
                    {
                        HiddenValue: "0",
                        VisibleValue: "No"
                    },
                    {
                        HiddenValue: "1",
                        VisibleValue: "Yes"
                    }
                ];

                userVM.getProcessStatusVisibleValue = function (HiddenValue) {
                    var data = userVM.ProcessStatus.filter(function (item) {
                        return item.HiddenValue == HiddenValue
                    })[0];

                    if (data) {
                        return data.VisibleValue;
                    }
                    else {
                        return 'N/A';
                    }
                }
                userVM.getHolidayStatusVisibleValue = function (HiddenValue) {
                    var data = userVM.HolidayStatus.filter(function (item) {
                        return item.HiddenValue == HiddenValue
                    })[0];
                    if (data) {
                        return data.VisibleValue;
                    }
                    else {
                        return 'N/A';
                    }
                }

                userVM.deleteHoliday = function (UserHolidayID) {
                    var index = userVM.holidayItems.data.findIndex(x => x.UserHolidayID == UserHolidayID);
                    userVM.holidayItems.data.splice(index, 1);
                    userVM.container.userHolidayGrid.dataSource.read();
                }

                userVM.onHolidayStartDateSelected = function (selectedDate) {
                    if (selectedDate != null) {
                        userVM.minHolidayEndDate = new Date(moment(new Date(selectedDate)).endOf('day').toDate().toJSON());//start Date
                    }
                };

                userVM.disableHolidayDelete = function (dataItem) {
                    if (dataItem.IsActive == "0" && dataItem.IsProcessed == "0") {
                        return false;
                    }
                    else {
                        return true;
                    }
                }

                userVM.addHolidayData = function () {
                    if (userVM.HolidayData.HolidayStartDate && userVM.HolidayData.HolidayEndDate) {
                        userVM.HolidayData.UserID = $stateParams.Id;
                        userVM.HolidayData.IsActive = 0;
                        userVM.HolidayData.IsProcessed = 0;
                        userVM.holidayItems.data.push(JSON.parse(JSON.stringify(userVM.HolidayData)));
                        userVM.container.userHolidayGrid.dataSource.read();
                    }
                    else {
                        ToastService.showCustomToast("error", "Please Fill The Form");
                    }
                }

                userVM.changeHolidayStartDate = function (startDateTime) {
                    if (!startDateTime) {
                        userVM.minHolidayEndDate = new Date((moment(new Date('1/1/1970')).startOf('day').toDate().toJSON()));
                    }
                    else {
                        userVM.minHolidayEndDate = new Date((moment(new Date(startDateTime)).startOf('day').toDate().toJSON()));

                        if (startDateTime > userVM.HolidayData.HolidayEndDate) {
                            userVM.HolidayData.HolidayEndDate = new Date((moment(new Date(userVM.HolidayData.HolidayStartDate)).startOf('day').toDate().toJSON()));
                        }
                    }

                }
                userVM.changeHolidayEndDate = function () {

                }

                userVM.updateUserHolidays = function () {
                    tmxResource('User').getByAction('UpdateUserHolidays/' + $stateParams.Id, true, 'put', userVM.holidayItems.data).then(function () {
                        holidaysLoadedFromServer = false;
                        userVM.container.userHolidayGrid.dataSource.read();
                    });
                }


                userVM.showSimpleDialog = function (title, message, callback) {
                    var alertConfig = {
                        title: title,
                        htmlContent: message,
                        ok: 'OK'
                    };
                    var alert = $mdDialog.alert(alertConfig);
                    $mdDialog
                        .show(alert)
                        .finally(function () {
                            alert = undefined;
                            if (exists(callback)) callback();
                        });
                }


                userVM.mainGridOptions = {
                    dataSource: {
                        transport: {
                            read: function (o) {
                                if (holidaysLoadedFromServer) {
                                    userVM.holidayItems = {
                                        AggregateResults: null,
                                        Data: userVM.holidayItems.data,
                                        Errors: null,
                                        Total: userVM.holidayItems.data.length,
                                        data: userVM.holidayItems.data,
                                    };

                                    o.success(userVM.holidayItems);
                                    userVM.HolidayData = {};
                                    userVM.HolidayData.HolidayStartDate = new Date(moment(new Date()).startOf('day').toDate().toJSON())
                                    userVM.HolidayData.HolidayEndDate = new Date((moment(new Date()).startOf('day').add(1, 'minute').toDate().toJSON()));
                                    userVM.minHolidayEndDate = new Date((moment(new Date(userVM.HolidayData.HolidayStartDate)).startOf('day').toDate().toJSON()));
                                }
                                else {
                                    tmxResource('User/GetHolidaysByUser/' + $stateParams.Id).getByParams(o, true).then(function (response) {
                                        userVM.holidayItems = {
                                            AggregateResults: null,
                                            Data: response.data,
                                            Errors: null,
                                            Total: response.data.length,
                                            data: response.data,
                                        };
                                        o.success(userVM.holidayItems);
                                        holidaysLoadedFromServer = true;

                                    });
                                }
                            },
                            update: function () { },
                            destroy: function () { },
                            dataType: "json"
                        },
                        schema: {
                            data: "data",
                            total: "Total"
                        },
                        serverPaging: false,
                        serverFiltering: false,
                        serverSorting: false,
                        sort: [{ field: "HolidayStartDate", dir: "asc" }],
                    },
                    pageable: {
                        refresh: true,
                        pageSizes: true,
                        pageSize: 10,
                        buttonCount: 5
                    },
                    pdf: {
                        allPages: true,
                        fileName: "Users.pdf"
                    },
                    excel: {
                        fileName: "Users.xlsx"
                    },
                    sortable: true,
                    scrollable: false,
                    columns: userVM.holidayGridColumn
                };

                userVM.date = new Date().toJSON()
                userVM.minStartDate = moment(new Date()).startOf('day').toDate().toJSON();
                userVM.searchText = null;
                userVM.userPasswordPrivileges = JSON.parse(localStorage.getItem('LoggedInUserPrivileges')).entities.UserPassword;
                userVM.PrimaryNationalIdentifierValueMaxLength = 10;
                userVM.ContactNumberMaxLength = 13;
                userVM.showEffectiveEndDate = true;
                userVM.phoneNumberRequired = true;
                userVM.showAmountLimits = true;
                userVM.checkPermission = tmxUtility.checkPermission;
                userVM.formatTime=tmxUtility.formatDateTimeForCompany;


                (function populateConfigurations() {
                    var configurations = cacheStore.get("Configurations");

                    if (configurations) {
                        userVM.loginIntegrationTenant = configurations.filter(function (item) {
                            return item.ConfigurationKey == 'USER_LOGIN_API_TYPE';
                        })[0];

                        if (userVM.loginIntegrationTenant && vitasTenants.indexOf(userVM.loginIntegrationTenant.ConfigurationValue.toLowerCase()) > -1) {
                            userVM.showLoginToServer = true;
                        }

                        userVM.FIELD_LENGTH = configurations.filter(function (item) {
                            return item.ConfigurationKey == 'FIELD_LENGTH';
                        })[0]

                        if (userVM.FIELD_LENGTH && userVM.FIELD_LENGTH.ConfigurationValue && JSON.parse(userVM.FIELD_LENGTH.ConfigurationValue)['PrimaryNationalIdentifierValue']) {
                            userVM.PrimaryNationalIdentifierValueMaxLength = JSON.parse(userVM.FIELD_LENGTH.ConfigurationValue)['PrimaryNationalIdentifierValue']['Max'];
                        }

                        if (userVM.FIELD_LENGTH && userVM.FIELD_LENGTH.ConfigurationValue && JSON.parse(userVM.FIELD_LENGTH.ConfigurationValue)['ContactNumber']) {
                            userVM.ContactNumberMaxLength = JSON.parse(userVM.FIELD_LENGTH.ConfigurationValue)['ContactNumber']['Max'];
                        }

                    }
                    var INTEGRATION_TENANT = tmxUtility.getConfigurationValue(configurations, 'INTEGRATION_TENANT').toLowerCase();
                    if (INTEGRATION_TENANT == TMX_FINANCE_CONSTANTS.TENANTS.SAMBA) {
                        userVM.showEffectiveEndDate = true;
                        userVM.phoneNumberRequired = false;
                        userVM.showAmountLimits = false;
                    }
                    userVM.enableServerUsername = INTEGRATION_TENANT == TMX_FINANCE_CONSTANTS.TENANTS.VITAS_LEB;

                })();

                userVM.changePassword = function () {
                    userVM.loading = true;
                    userVM.changePasswordData.Email = userVM.vm.EmailAddress;
                    tmxResource("User").getByAction("ChangePassword", false, 'put', userVM.changePasswordData)
                        .then(function (data) {
                            console.log(userVM.passwordForm);
                            userVM.changePasswordData.NewPassword = '';
                            userVM.changePasswordData.ConfirmPassword = '';
                            userVM.passwordForm.$setPristine();
                            userVM.passwordForm.$setUntouched();

                            ToastService.showCustomToast('success', data.data.status.message);
                        }).finally(function () { userVM.loading = false; });
                    
                    //    $http.put(APP_CONSTANTS.AuthServer + '/api/account/changeuserpassword', userVM.changePasswordData)
                        
                };

                userVM.userRoleChange = function () {
                    console.log(userVM.vm.TmxUserRoleMapping);
                }

                userVM.NationalIdentifierType = function (value) {
                    if (value) {
                        userVM.isNationalIDRequired = true;
                    }
                    else {
                        userVM.isNationalIDRequired = false;
                    }

                }

                userVM.loginToServerClick = function () {
                    tmxResource("Integration").getByAction("Login", false, 'post', { Username: userVM.vm.ServerUserName }).then(function (response) {
                        userVM.vm.ServerBranchID = response.data.BranchId;
                        userVM.vm.ServerUserID = response.data.UserID;
                    });

                }
                userVM.checkEmail = function (email) {

                    userVM.vm.ServerUserName = email.substr(0, email.indexOf('@'));

                    if (angular.isDefined(email)) {
                        if (!userVM.isEdit) {

                            var action = 'emailExists/';
                            var data = {
                                "Parameter": email
                            }

                            $http.put(APP_CONSTANTS.backend + "User/" + action, data).then(function (response) {
                                if (response.data.data == true) {
                                    userVM.dialogForm.EmailAddress.$error.alreadyexist = true;
                                    userVM.dialogForm.EmailAddress.$valid = false;
                                    userVM.dialogForm.EmailAddress.$invalid = true;
                                }
                                else if (userVM.dialogForm.EmailAddress.$error.alreadyexist) {
                                    userVM.dialogForm.EmailAddress.$error = {};
                                    userVM.dialogForm.EmailAddress.$valid = true;
                                    userVM.dialogForm.EmailAddress.$pristine = true;
                                    userVM.dialogForm.EmailAddress.$dirty = false;
                                    userVM.dialogForm.EmailAddress.$invalid = false;
                                }
                            });
                        }

                    }

                };


                userVM.formatPhoneNumber = function (PhoneNumber1) {
                    if (angular.isDefined(PhoneNumber1) && PhoneNumber1 != null) {
                        var country = PhoneNumber1.slice(0, 2);
                        var city = PhoneNumber1.slice(2, 5);
                        var number = PhoneNumber1.slice(5);
                        number = number.slice(0, 3) + '-' + number.slice(3, 7);
                        return "+" + country + " (" + city + ") " + number;
                    }
                    return "N/A";
                };               

                userVM.updateDevicePhoneNumber = function (deviceId) {
                    var changed = false;
                    if (userVM.Devices) {
                        for (var i = 0; i < userVM.Devices.length; i++) {
                            if (userVM.Devices[i].HiddenValue == deviceId) {
                                userVM.PhoneNumber = userVM.formatPhoneNumber(userVM.Devices[i].PhoneNumber);
                                userVM.vm.ContactNumber = angular.copy(userVM.PhoneNumber);
                                changed = true;
                            }
                        }
                    }
                    if (!changed)
                        userVM.PhoneNumber = "";
                };

                userVM.getLocationName = function (response, LocationId) {
                    if (LocationId == null)
                        return '---';
                    else {
                        for (var j = 0; j < response.length; j++) {
                            if (response[j].LocationId == LocationId)
                                return response[j].LocationName;
                        }
                    }
                };
                ////////////////////////////////DATE START SELECTION//////////////////////////////////////////////////////////////////
                userVM.onStartDateSelected = function (selectedDate) {
                    if (selectedDate != null) {

                        userVM.vm.EffectiveStartDate = new Date(moment(new Date(selectedDate)).startOf('day').toDate().toJSON());//start Date
                        // userVM.vm.EffectiveStartDate = tmxUtility.setStartDate(selectedDate).toJSON();//start Date
                        userVM.StartDateInvalid = false;
                        userVM.minEndDate = userVM.vm.EffectiveStartDate;//ensuring that end date >= start Date
                    }
                    else {
                        userVM.StartDateInvalid = true;
                    }
                };
                ///////////////////////////////DATE END SELECTION /////////////////////////////////////////////////////////////////////
                userVM.onEndDateSelected = function (selectedDate) {
                    if (selectedDate != null) {
                        userVM.vm.EffectiveEndDate = new Date(moment(new Date(selectedDate)).endOf('day').toDate().toJSON());//start Date
                        // userVM.vm.EffectiveEndDate = tmxUtility.setEndDate(selectedDate).toJSON();//end Date
                        userVM.EndDateInvalid = false;
                    }
                    else {
                        userVM.EndDateInvalid = true;
                    }
                };
                ///////////////////////////// GET FORM ERRORS//////////////////////////////////////////////////////////////////////////
                userVM.getFormErrors = function () {
                    if (angular.isDefined(userVM.dialogForm)) {
                        if (userVM.dialogForm.$invalid || userVM.vm.EffectiveEndDate == "Invalid Date" || userVM.vm.EffectiveEndDate == null) {
                            return userVM.dialogForm.$error;
                        }
                    }
                    return undefined;
                };

                userVM.getDateErrors = function () {
                    return userVM.vm.EffectiveEndDate;
                };

                ////////////////////////////////////////////////////////////////////////////////
                userVM.errorChanged = function (newErrors, oldErrors) {
                    if (newErrors != oldErrors || userVM.vm.EffectiveEndDate == "Invalid Date" || userVM.vm.EffectiveEndDate == null) {
                        userVM.dirtyFormControls = [];
                        angular.forEach(userVM.dialogForm, function (value) {
                            if ((typeof value === 'object' && value.hasOwnProperty('$modelValue') && value.$invalid) ||
                                (typeof value === 'object' && value.$viewValue == "Invalid Date")) {
                                userVM.dirtyFormControls.push(value.$name);
                            }
                        });

                        userVM.error_msg = "Required field(s): ";
                        for (var i = 0; i < userVM.dirtyFormControls.length; i++) {
                            if (i == userVM.dirtyFormControls.length - 1) {
                                userVM.error_msg += userVM.dirtyFormControls[i];
                            }
                            else
                                userVM.error_msg += userVM.dirtyFormControls[i] + ", ";
                        }

                    }

                };

                ///////////////////////////////////////////SAVE////////////////////////////////////////////////////////////////////////
                userVM.save = function (action, form) {


                    userVM.loading = true;
                    userVM.formSubmitted = true;
                    form.$submitted = true;

                    if (!angular.isDefined(userVM.vm.DeviceId) || userVM.vm.DeviceId == null) {
                        userVM.vm.DeviceId = 0;
                        userVM.vm.TmxUserDevice = [];
                    }

                    if (form.$invalid) {
                        userVM.formInvalid = true;
                        userVM.loading = false;
                        return;
                    }
                    if (tmxUtility.exists(userVM.vm.TmxCompanyBranchUsersMapping) && userVM.vm.TmxCompanyBranchUsersMapping.length > 1) {
                        let branchIdList = userVM.vm.TmxCompanyBranchUsersMapping.map(x => Number(x.CompanyBranchId));
                        if (tmxUtility.hasDuplicates(branchIdList)) {
                            ToastService.showCustomToast("error", "Please delete duplicate branches to continue.");
                            userVM.loading = false;
                            return;
                        }
                    }

                    if (tmxUtility.exists(userVM.vm.TmxCompanyBranchUsersMapping) && userVM.vm.TmxCompanyBranchUsersMapping.length > 0) {
                        userVM.vm.TmxLoanLimit = [];
                        userVM.vm.TmxCompanyBranchUsersMapping.forEach(cb => {
                            if (tmxUtility.exists(cb.BranchLoanLimit)) {
                                cb.BranchLoanLimit.CompanyBranchId = cb.CompanyBranchId;
                                cb.BranchLoanLimit.RoleId = userVM.vm.TmxUserRoleMapping[0].RoleId;
                                cb.BranchLoanLimit.LocationId = userVM.vm.LocationId;
                                userVM.vm.TmxLoanLimit.push(cb.BranchLoanLimit);
                            }
                        });
                    }

                    userVM.formInvalid = false;

                    userVM.vm.UserName = userVM.vm.EmailAddress;
                    //setting updated User in Service


                    ///////////////////////////////////////////////////////////////////////////////////////
                    userVM.vm.$saveOrUpdate().then(function (promise) {
                        userVM.loading = false;
                        if (angular.isDefined($state.data.grid.userGrid)) $state.data.grid.userGrid.dataSource.read();
                        if (angular.isDefined(promise)) {
                            if (promise.status >= 400) {
                                userVM.formSubmitted = false;
                                var displayMsg = "";
                                if (angular.isDefined(promise.data.ModelState)) {
                                    var models = Object.keys(promise.data.ModelState);
                                    models.forEach(function (key) {
                                        displayMsg += (promise.data.ModelState[key])
                                    })
                                }
                                else
                                    displayMsg = promise.data.Message;
                                ToastService.showCustomToast("error", displayMsg);
                            }
                            else {
                                ////////////////////////////////////
                                if (action == "save") {
                                    $state.searchClear = true;
                                    $state.go("^");
                                }
                                else if (action == "saveandnew") {
                                    $state.searchClear = true;
                                    $state.reload($state.current);
                                }
                            }
                        }
                        else
                            ToastService.showCustomToast("error", "Some Error Occured");
                    });
                };//function end
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                userVM.getCompanyAndItsBranch = function (BranchId) {

                    userVM.BranchService.getCompanyByBranchId(BranchId)
                        .then(function (data) {
                            if (angular.isDefined(data)) {
                                userVM.data = data;
                                userVM.vm.CompanyId = userVM.data.data.CompanyId;
                            }

                        });
                };
                ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                userVM.updateBranches = function (stateId) {
                    if ((!(angular.isDefined(stateId)) || stateId === null)) {
                        userVM.vm.Branches = [];
                        userVM.vm.CompanyBranchId = null;
                        userVM.isEnableChip = true;
                        userVM.vm.TmxCompanyBranchUsersMapping = [];
                        return;
                    }


                    BranchService.CompanyBranchLov(stateId).then(
                        function (data) {
                            // decorateForSelect(data.data);
                            userVM.Branches = data.data;
                            userVM.isEnableChip = false;

                        }
                    );
                }

                /////////////////////////////////////////////////////////////////////////////////////////////////////////////
                userVM.getReportingBoss = function (index) {
                    $timeout(function () {
                        var mappingObj = userVM.vm.TmxCompanyBranchUsersMapping[index];
                        let branchid = mappingObj.CompanyBranchId;
                        if (branchid) {
                            UsersService.getUserByBranchId(branchid).then(function (response) {
                                mappingObj.BranchUsers = response.data.map(x => ({ LookupId: x.UserId, VisibleValue: x.UserName }));
                                // userVM.reportingUser = response.data;
                                // userVM.reportingUser.forEach(function (user) {
                                //     user.LookupId = user.UserId;
                                //     user.VisibleValue = user.UserName;
                                // });
                            });
                        }
                        else {
                            mappingObj.BranchUsers = [];
                            mappingObj.ReportingBossId = null;
                        }
                    });

                }

                ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                userVM.getDesignationByUserID = function (user) {
                    if (angular.isDefined(userVM.designationsLookup)) {
                        for (var i = 0; i < userVM.designationsLookup.data.length; i++) {
                            if (userVM.designationsLookup.data[i].HiddenValue == user)
                                return userVM.designationsLookup.data[i].VisibleValue;
                        }
                    }
                }

                lookupService.getLookupByType(lkupType.DESIGNATION).then(function (response) {

                    userVM.designationsLookup = response;
                });
                ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                lookupService.getLookupByType(lkupType.ID_TYPE).then(function (response) {

                    userVM.IdentifierLkp = response;
                });
                ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

                /////////////////////////// CANCEL FORM/////////////////////////////////////////////////////////////////////////////////
                userVM.cancel = function () {
                    $state.searchClear = true;
                    $state.go("^");
                };

                ////////////////////////////////INITIALIZATIONS////////////////////////////////////////////////////////////////////////
                userVM.loading = false;
                ///////populate data in dropdowns /////////

                userVM.gridData = resolvedData.locations;
                userVM.usersLookup = resolvedData.Users.data;
                userVM.Devices = resolvedData.Devices.data;
                userVM.isEdit = false;
                userVM.dirtyFormControls = [];
                userVM.StartDateInvalid = false;
                userVM.EndDateInvalid = false;
                userVM.reportingUser = [];
                userVM.Companies = resolvedData.Company.data;
                userVM.usersRolesLov = resolvedData.RoleLov.data;
                userVM.BranchService = BranchService;
                userVM.UserRoleModel = [];
                userVM.enableUnlockUser = false;
                userVM.showStatus = true;
                userVM.lookup = {};
                userVM.type = [];

                
                userVM.authUser = resolvedData.AuthUser ? resolvedData.AuthUser.data : null;

                if (userVM.authUser && (userVM.authUser.lockoutEnabled || exists(userVM.authUser.lockoutEndDateUtc)) && (new Date(userVM.authUser.lockoutEndDateUtc) > utcDate)){
                    userVM.enableUnlockUser = true;
                    userVM.authUser.lockoutEnabled=true;
                }


                //////////////////////////DATE TIME PICKER CONFIGURATIONS/////////////////////
                userVM.currentdateObj = new Date();
                userVM.date = userVM.currentdateObj.toJSON();

                userVM.StartDateReadonly = false;
                userVM.EndDateReadonly = false;
                if ($state.data.info == true) {
                    userVM.readonly = true;
                    userVM.StartDateReadonly = true;
                    userVM.EndDateReadonly = true;

                }


                lookupService.getUserTypes().then(function (types) {

                    angular.forEach(types, function (type) {
                        type.HiddenValue = type.LookupId;
                    });
                    userVM.lookup.type = types;
                });
                userVM.lookup.status = [
                    {
                        HiddenValue: "active",
                        VisibleValue: "Active",
                    },
                    {
                        HiddenValue: "inactive",
                        VisibleValue: "Inactive",
                    }
                ];
                userVM.lookup.users = resolvedData.Users.data;
                userVM.BranchError = false;
                userVM.RoleError = false;

                userVM.strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*-_`~])(?=.{10,})");
                userVM.mediumRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*-_`~])(?=.{8,})");
                userVM.passwordStrength = {
                    "float": "left",
                    "width": "33%",
                    "height": "25px"
                };
                userVM.analyze = function (value) {
                    if (userVM.strongRegex.test(value)) {
                        userVM.passwordStrength["background-color"] = "green";
                        userVM.passwordStrength["width"] = "100%";
                    }
                    else if (userVM.mediumRegex.test(value)) {
                        userVM.passwordStrength["background-color"] = "orange";
                        userVM.passwordStrength["width"] = "66%";
                    }
                    else {
                        userVM.passwordStrength["background-color"] = "red";
                        userVM.passwordStrength["width"] = "33%";
                    }
                };


                userVM.enableAuthUser = function () {
                    userVM.loading = true;
                    if (exists(userVM.vm.UserId) && userVM.enableUnlockUser) {
                        //$http.put(APP_CONSTANTS.AuthServer + '/api/user/Unlock/' + userVM.vm.UserId)
                        tmxResource("User").getByAction("Unlock/" + userVM.vm.UserId, false, 'put', null)
                            .then(function (response) {
                                if (response.data.status.code == "200") {
                                    ToastService.showCustomToast('success', "User has been Successfully Enabled");
                                    userVM.enableUnlockUser = false;
                                    userVM.authUser.lockoutEnabled = false;
                                }
                            }).finally(function () {
                                userVM.loading = false;
                            });
                    }
                };

                userVM.addBranch = function () {
                    if (!tmxUtility.exists(userVM.vm.TmxCompanyBranchUsersMapping)) {
                        userVM.vm.TmxCompanyBranchUsersMapping = [];
                    }
                    userVM.vm.TmxCompanyBranchUsersMapping.push({
                        BranchLoanLimit: {}
                    });
                };
                userVM.removeBranch = function (index) {
                    userVM.vm.TmxCompanyBranchUsersMapping.splice(index, 1);
                };

                (function InitializeUserVMForAddEdit() {
                    if (angular.isDefined(resolvedData.User.data)) { // Edit Case

                        userVM.vm = resolvedData.User.data;

                        if (userVM.vm.EmailAddress)
                            userVM.vm.ServerUserName = userVM.vm.EmailAddress.substr(0, userVM.vm.EmailAddress.indexOf('@'));

                        userVM.minEndDate = userVM.vm.EffectiveStartDate;
                        userVM.vm.EffectiveStartDate = new Date(userVM.vm.EffectiveStartDate);
                        userVM.isEdit = true;
                        if (userVM.vm.EffectiveStartDate > new Date()) {
                            userVM.StartDateReadonly = false;
                            userVM.minStartDate = moment(new Date()).endOf('day').toDate().toJSON();
                        }
                        else {
                            userVM.StartDateReadonly = true;
                            userVM.minStartDate = userVM.vm.EffectiveStartDate;
                        }


                        if (angular.isDefined(userVM.vm.TmxCompanyBranchUsersMapping)) {
                            if (userVM.vm.TmxCompanyBranchUsersMapping.length > 0) {

                                userVM.getCompanyAndItsBranch(userVM.vm.TmxCompanyBranchUsersMapping[0].CompanyBranchId, userVM.vm.TmxCompanyBranchUsersMapping);
                            }
                        }

                        if (angular.isDefined(userVM.vm.CompanyId) && userVM.vm.CompanyId != null) {
                            userVM.updateBranches(userVM.vm.CompanyId);
                        }
                    }
                    else {// Add case

                        userVM.vm = resolvedData.User;
                        userVM.vm.TmxUserRoleMapping = [];
                        userVM.vm.TmxCompanyBranchUsersMapping = [];
                        userVM.StartDateReadonly = false;
                        userVM.vm.EffectiveStartDate = new Date(moment(new Date()).startOf('day').add(1, 'minutes').toDate().toJSON());
                        userVM.vm.EffectiveEndDate = new Date(moment(new Date("1-1-2099")).endOf('day').toDate().toJSON());
                        userVM.minEndDate = userVM.vm.EffectiveStartDate;
                    }
                    if (!userVM.vm.TmxLoanLimit) {
                        userVM.vm.TmxLoanLimit = [];
                    }
                    associateBranchLoanLimits();

                    if (userVM.vm.EffectiveEndDate < userVM.date) {
                        userVM.vm.status = "inactive";
                    }
                    else {
                        userVM.vm.status = "active";
                    }
                    userVM.updateDevicePhoneNumber(userVM.vm.DeviceId);

                    function associateBranchLoanLimits() {
                        userVM.vm.TmxCompanyBranchUsersMapping.forEach(cb => {
                            let branchLimit = userVM.vm.TmxLoanLimit.find(x => x.CompanyBranchID == cb.CompanyBranchId);
                            cb.BranchLoanLimit = branchLimit || {};
                        });
                    }
                })();


                (function SetFormState() {
                    if (exists(resolvedData.Requests, 'data.RequestId')) {
                        userVM.readonly = true;
                        userVM.isEdit = true;
                        userVM.StartDateReadonly = true;
                        userVM.EndDateReadonly = true;
                        userVM.showSimpleDialog('Alert', 'A modification request is already submitted for this user. You cannot make changes until the request is Approved/Rejected.');
                    }

                })();

                ////////////////////////////////////////////////////


            }]);
})();
